/**
 * V118-0-9: worked examples for `intake.extract_obligations` — three frozen few-shot laws of the 2026-10-30 crosswalk
 * (never scored, D-118-8). GENERATED by scripts/eval/law-intake/gen-fewshot.mjs; do not edit by hand.
 */
export const INTAKE_FEWSHOT_EXAMPLES = [
    {
        "law": "CA 2025 SB 524",
        "obligations": [
            {
                "section": "Cal. Penal Code §13663(a)",
                "excerpt": "“This report was written either fully or in part using artificial intelligence.”",
                "deontic": "obligation",
                "binds_whom": {
                    "scope": "public",
                    "actor_class": "public_body"
                },
                "obligation": "Each law enforcement agency must maintain a policy requiring any official report written fully or partly with AI to identify, on each page or in the body, every AI program used, carry the statement 'This report was written either fully or in part using artificial intelligence.', and bear the preparer's signature verifying review and accuracy.",
                "duty": "ai_generated_output_disclaimer"
            },
            {
                "section": "Cal. Penal Code §13663(b)(1), (c)",
                "excerpt": "the first draft created shall be retained by the agency for as long as the official report is retained.",
                "deontic": "obligation",
                "binds_whom": {
                    "scope": "public",
                    "actor_class": "public_body"
                },
                "obligation": "An agency using AI to draft an official report must keep the AI first draft for as long as the official report, plus an audit trail identifying who used AI to create the report and the video/audio footage used.",
                "duty": "audit_logging"
            },
            {
                "section": "Cal. Penal Code §13663(d)",
                "excerpt": "(1) A contracted vendor shall not share, sell, or otherwise use information provided by a law enforcement agency to be processed by artificial intelligence except for either of the following purposes:",
                "deontic": "prohibition",
                "binds_whom": {
                    "scope": "private",
                    "actor_class": "provider"
                },
                "obligation": "A vendor that supplies AI police-report drafting to law enforcement must not share, sell or otherwise use agency information processed by the AI, except for the agency's purposes or under a court order (access for troubleshooting, bias mitigation, accuracy improvement or system refinement is allowed).",
                "duty": "restricted_data_use_for_ai"
            }
        ]
    },
    {
        "law": "CT 2023 SB 1103",
        "obligations": [
            {
                "section": "PA 23-16 sec. 1(b), sec. 3(b) (Conn. Gen. Stat. 4a-2e)",
                "excerpt": "Not later than December 31, 2023, and annually thereafter, the Department of Administrative Services shall conduct an inventory of all systems that employ artificial intelligence",
                "deontic": "obligation",
                "binds_whom": {
                    "scope": "public",
                    "actor_class": "public_body"
                },
                "obligation": "Conduct an annual inventory of AI systems in use (name and vendor, capabilities and uses, whether used to make or support decisions, whether impact-assessed) and publish it.",
                "duty": "use_case_inventory"
            },
            {
                "section": "PA 23-16 sec. 2(c), sec. 3(d)(1) (Conn. Gen. Stat. 4-68jj)",
                "excerpt": "Beginning on February 1, 2024, no state agency shall implement any system that employs artificial intelligence (1) unless the state agency has performed an impact assessment",
                "deontic": "prohibition",
                "binds_whom": {
                    "scope": "public",
                    "actor_class": "public_body"
                },
                "obligation": "Do not implement an AI system unless an impact assessment under OPM (or Judicial Department) policies shows it will not result in unlawful discrimination or disparate impact.",
                "duty": "impact_assessment"
            },
            {
                "section": "PA 23-16 sec. 2(b), sec. 3(c)",
                "excerpt": "Not later than February 1, 2024, the Office of Policy and Management shall develop and establish policies and procedures concerning the development, procurement, implementation, utilization and ongoing assessment",
                "deontic": "obligation",
                "binds_whom": {
                    "scope": "public",
                    "actor_class": "public_body"
                },
                "obligation": "Adopt and post policies and procedures governing development, procurement, implementation, use and ongoing assessment of state agency AI systems, sufficient to prevent unlawful discrimination and requiring pre-implementation impact assessment.",
                "duty": "ai_use_policy"
            },
            {
                "section": "PA 23-16 sec. 1(c), sec. 3(d)(2)",
                "excerpt": "Beginning on February 1, 2024, the Department of Administrative Services shall perform ongoing assessments of systems that employ artificial intelligence",
                "deontic": "obligation",
                "binds_whom": {
                    "scope": "public",
                    "actor_class": "public_body"
                },
                "obligation": "Perform ongoing assessments of state agency AI systems to ensure none results in unlawful discrimination or disparate impact.",
                "duty": "bias_evaluation"
            }
        ]
    },
    {
        "law": "IL 2025 HB 1806",
        "obligations": [
            {
                "section": "225 ILCS 155/15(a); 155/20(b); 155/30",
                "excerpt": "A licensed professional may not allow artificial intelligence to do any of the following: (1) make independent therapeutic decisions; (2) directly interact with clients in any form of therapeutic communication;",
                "deontic": "prohibition",
                "binds_whom": {
                    "scope": "private",
                    "actor_class": "deployer"
                },
                "obligation": "A licensed professional may use AI only for administrative or supplementary support, keeps full responsibility for it, and may not let AI make independent therapeutic decisions, communicate therapeutically with clients, produce unreviewed treatment recommendations or plans, or detect emotions or mental states.",
                "duty": "ai_therapy_restriction"
            },
            {
                "section": "225 ILCS 155/15(b); 155/10 (\"Consent\")",
                "excerpt": "No licensed professional shall be permitted to use artificial intelligence to assist in providing supplementary support in therapy or psychotherapy where the client's therapeutic session is recorded or transcribed unless:",
                "deontic": "prohibition",
                "binds_whom": {
                    "scope": "private",
                    "actor_class": "deployer"
                },
                "obligation": "Before using AI for supplementary support where a client's session is recorded or transcribed, inform the client in writing that AI will be used and its specific purpose, and obtain the client's consent.",
                "duty": "informed_consent_for_ai_use"
            },
            {
                "section": "225 ILCS 155/20(a); 155/35",
                "excerpt": "An individual, corporation, or entity may not provide, advertise, or otherwise offer therapy or psychotherapy services, including through the use of Internet-based artificial intelligence, to the public in this State unless the therapy or psychotherapy services are conducted by an individual who is a licensed professional.",
                "deontic": "prohibition",
                "binds_whom": {
                    "scope": "private",
                    "actor_class": "deployer"
                },
                "obligation": "Do not provide, advertise or offer therapy or psychotherapy to the public in Illinois, including through Internet-based AI, unless a licensed professional conducts it.",
                "duty": "ai_therapy_restriction"
            }
        ]
    }
];
//# sourceMappingURL=intake-fewshot.js.map